import useSWR from 'swr';
import { TeamComparison } from '@amf/shared/types/graphql';

const getKey = (leagueId: string, firstTeamId: string, secondTeamId: string) => {
  const params = new URLSearchParams({ leagueId, firstTeamId, secondTeamId });
  return `/api/team/comparison?${params}`;
};

function useTeamComparison(leagueId: string, firstTeamId: string, secondTeamId: string) {
  const { data, error } = useSWR<TeamComparison | null>(
    getKey(leagueId, firstTeamId, secondTeamId),
  );

  return {
    error,
    comparison: data,
    loading: !data && !error,
  };
}

export default useTeamComparison;
